export const common = {
  siteName: "Discover UB",
  tagline: "Улаанбаатарт яг одоо юу хийх вэ",
  searchPlaceholder: "Хоол, уур амьсгал эсвэл газар хайх…",
  language: "Монгол",
  switchLanguage: "English",
  
  nav: {
    home: "Нүүр",
    mapView: "Газрын зураг"
  },
  
  bottomNav: {
    home: "Нүүр",
    map: "Газрын зураг",
    saved: "Хадгалсан",
    profile: "Профайл",
    comingSoon: "Удахгүй"
  },
  
  moods: {
    chill: "Тайван",
    eat: "Идэх",
    party: "Зугаалах",
    romantic: "Романтик",
    explore: "Аялах",
    recover: "Амрах"
  },
  
  categories: {
    all: "Бүгд",
    eat: "Рестораны",
    party: "Шөнийн амьдрал",
    pub: "Паб",
    explore: "Үзвэр газрууд",
    romantic: "Болзооны газар",
    unique: "Онцгой газрууд",
    spa: "Спа & Массаж",
    massage: "Массажны газар",
    coffee: "Кофе шоп",
    shopping: "Дэлгүүр"
  },
  
  filters: {
    day: "Өдөр",
    night: "Шөнө",
    openNow: "Одоо нээлттэй",
    budget: "Төсөв",
    distance: "Ойролцоо"
  },
  
  placeCard: {
    verified: "Баталгаажсан",
    open: "Нээлттэй",
    closed: "Хаалттай",
    hours: "Цаг",
    contact: "Холбоо барих",
    directions: "Чиглэл",
    views: "үзэлт"
  },

  placeDetail: {
    about: "Тухай",
    insiderTip: "Зөвлөгөө",
    address: "Хаяг",
    amenities: "Үйлчилгээ",
    bestTime: "Зочлох хамгийн тохиромжтой цаг",
    daytime: "Өдөр",
    nighttime: "Шөнө",
    share: "Хуваалцах",
    save: "Хадгалах"
  },
  
  trending: {
    title: "Одоо Эрэлттэй",
    busyNow: "Одоо завгүй",
    newThisWeek: "Энэ долоо хоногт шинэ",
    localsPicks: "Нутгийнхны сонголт"
  },
  
  results: {
    showing: "Харуулж байна",
    places: "газар"
  }
};

export default common;